import { Stack, TooltipHost } from "@fluentui/react";

import { CopyPaste } from "@/components/CopyPaste";
import {
  contractShipmentStatusColors,
  contractShipmentStatusLabels,
  contractShipmentTypeLabels
} from "@/interfaces/modules/contract-shipments";
import { Badge } from "@/modules/Contracts/styles";
import { ContractItem } from "@/modules/Contracts/types";

interface ShipmentCellProps {
  item: ContractItem;
}

export function ShipmentCell({ item }: ShipmentCellProps) {
  if (!item.contractShipments?.length) {
    return <>—</>;
  }

  return (
    <Stack
      horizontalAlign="start"
      tokens={{ childrenGap: 4 }}
      styles={{ root: { width: "100%" } }}
    >
      {item.contractShipments.map(shipment => (
        <TooltipHost
          key={shipment.id}
          content={`${contractShipmentTypeLabels[shipment.type]} · ${
            contractShipmentStatusLabels[shipment.status]
          }`}
          styles={{
            root: {
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
              maxWidth: "100%"
            }
          }}
        >
          <Badge
            bgColor="transparent"
            display="flex"
            justifyContent="center"
            wordWrap="break-word"
            whiteSpace="unset"
            fontWeight="600"
            fontColor={contractShipmentStatusColors[shipment.status]}
            border={`1px solid ${contractShipmentStatusColors[shipment.status]}`}
            style={{
              alignItems: "center",
              gap: 6,
              minWidth: "160px",
              maxWidth: "160px",
              padding: "2px"
            }}
          >
            <CopyPaste
              valueToCopy={shipment.code}
              tooltipText="Copiar código do envio"
              iconPosition="before"
            >
              <span style={{ overflowWrap: "anywhere", minWidth: 0 }}>
                {shipment.code}
              </span>
            </CopyPaste>
          </Badge>
        </TooltipHost>
      ))}
    </Stack>
  );
}
